import { render, staticRenderFns } from "./CartNonVueAdapter.vue?vue&type=template&id=641f5410"
import script from "./CartNonVueAdapter.vue?vue&type=script&lang=js"
export * from "./CartNonVueAdapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports